import { faCircleCheck, faCreditCard, faTrashAlt, faUser } from "@fortawesome/free-regular-svg-icons";
import { faExclamationCircle, faExclamationTriangle, faFileSignature, faPhone, faArrowsTurnToDots } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Form, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import StudentAttendancesDropdown from "../dropdowns/StudentAttendancesDropdown";
import "./StudentAttendanceData.css";
import ConfirmModal from "../modals/ConfirmModal";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const StudentAttendanceData = (props) => {
    const { t } = useTranslation();
    const { setAlerts, checkServerData, changeView } = useContext(BasicContext);
    const { student, i, onChangeStatus, blockForm, classData, reloadData, tabKey, setChangedForm } = props;
    const [showDeleteAttendanceModal, setShowDeleteAttendanceModal] = useState(false);
    const [blockDeleteBtn, setBlockDeleteBtn] = useState(false);
    const [blockChangePassAttachmentBtn, setBlockChangePassAttachmentBtn] = useState(false);

    const deleteAttendance = async (userID) => {
        const res = await postMethod("/delete-attendance", { classData: classData, userID: userID });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "deleteAttendance" }]);
            reloadData();
        } else setBlockDeleteBtn(false);
    };

    const checkChangePassAttachmentPrivilage = async () => {
        const res = await postMethod("/change-pass-attachment-privilege");
        if (checkServerData(res)) {
        } else {
            setAlerts([{ variant: "danger", message: t("error.permissionDenied"), fading: 3500, id: "changePassAttachmentPrivilagePermissionDenied" }]);
            setBlockChangePassAttachmentBtn(true);
        }
    };

    useEffect(() => {
        checkChangePassAttachmentPrivilage();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <tr>
                <td rowSpan={student.u2c_waitlist_date && student.u2c_status_code === "WAITLIST" ? 5 : 4} className="align-top text-center pt-4 pt-lg-0" style={{ wordBreak: "keep-all" }}>
                    <span className="">{i + 1}.</span>
                </td>
                <td className="px-0 border-bottom-0 pb-0" style={{ width: "35px" }}>
                    {student.user_avatar_name ? (
                        <Image
                            src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${student.user_avatar_name}`}
                            alt={`${student.user_name} ${student.user_surname} avatar`}
                            className="avatar"
                        />
                    ) : (
                        <div className="no-avatar mx-auto">
                            <FontAwesomeIcon icon={faUser} />
                        </div>
                    )}
                </td>
                <td className="border-bottom-0 pb-0" style={{ width: "37%" }}>
                    <Button variant="link" onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: student.user_id } })} className="p-0 text-start">
                        {student.user_name}
                        <br />
                        {student.user_surname}
                    </Button>
                </td>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                    {student.pass_name}
                </td>
                <td rowSpan={student.u2c_waitlist_date && student.u2c_status_code === "WAITLIST" ? 5 : 4} className="align-middle text-center">
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 150, hide: 100 }}
                        overlay={<Tooltip id={`changePassAttachmentModalTooltip${i}`}>{t("classes.reattachingEntranceOnAnotherPass")}</Tooltip>}
                    >
                        <Button
                            variant="outline-secondary"
                            disabled={blockChangePassAttachmentBtn}
                            onClick={() => changeView({ nav: "passes", sub: "changePassAttachment", params: { student: student, classData: classData } })}
                            className="me-lg-2 mb-3 mb-lg-0"
                        >
                            <FontAwesomeIcon icon={faArrowsTurnToDots} />
                        </Button>
                    </OverlayTrigger>

                    <Button variant="outline-danger" disabled={blockDeleteBtn} onClick={() => setShowDeleteAttendanceModal(student)}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0" colSpan={2}>
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    {student.user_phone}
                </td>
                <td className="border-bottom-0 pb-0">
                    {!student.up_activation_date ? (
                        <>
                            {t("passes.activationDate")}: <span className="opacity-50">{t("lack")}</span>
                            <br />
                            {t("passes.activationTill")}: <strong>{moment(student.up_due_date).format("YYYY-MM-DD")}</strong>
                        </>
                    ) : (
                        <>
                            {t("passes.activationDate")}:{" "}
                            <strong>
                                {moment(student.up_activation_date).format("YYYY-MM-DD")} - {moment(student.up_end_date).format("YYYY-MM-DD")}
                            </strong>
                        </>
                    )}
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0" colSpan={2}>
                    <FontAwesomeIcon icon={faFileSignature} className="me-2" />
                    {moment(student.u2c_create_date).format("YYYY-MM-DD HH:mm:ss")}
                </td>
                <td className="border-bottom-0 pb-0">
                    {student.up_paid === 0 && student.up_price > 0 ? (
                        <span className="text-danger bold">
                            <FontAwesomeIcon icon={faExclamationCircle} className="me-1" />
                            {t("passes.notPaid")}
                        </span>
                    ) : student.up_paid < student.up_price ? (
                        <span className="text-warning bold">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                            {t("passes.notFullyPaid")}
                        </span>
                    ) : student.up_paid > student.up_price ? (
                        <span className="text-warning bold">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                            {t("passes.overPaid")}
                        </span>
                    ) : (
                        <span className="text-success">
                            <FontAwesomeIcon icon={faCircleCheck} className="me-1" />
                            {t("passes.paid")}
                        </span>
                    )}
                </td>
            </tr>
            {student.u2c_waitlist_date && student.u2c_status_code === "WAITLIST" && (
                <tr>
                    <td className="border-bottom-0 pb-0" colSpan={3}>
                        {t("classes.waitingListDate")}: <strong>{moment(student.u2c_waitlist_date).format("YYYY-MM-DD HH:mm")}</strong>
                    </td>
                </tr>
            )}
            <tr>
                <td colSpan={3}>
                    <Form.Label>{t("status")}: </Form.Label>
                    <Form.Group className="d-inline-block ms-3" style={{ minWidth: "12rem" }}>
                        <StudentAttendancesDropdown value={student.ua_status_code} onChange={onChangeStatus} disabled={blockForm} id={`${tabKey}${i}`} />
                    </Form.Group>
                </td>
            </tr>

            {showDeleteAttendanceModal && (
                <ConfirmModal
                    show={true}
                    onClose={() => {
                        setAlerts([]);
                        setShowDeleteAttendanceModal(false);
                    }}
                    onProceed={() => {
                        setAlerts([{ variant: "info", message: t("info.deletingAttendance") }]);
                        setBlockDeleteBtn(true);
                        setChangedForm(true);
                        setTimeout(() => {
                            deleteAttendance(showDeleteAttendanceModal.user_id);
                        }, 200);
                    }}
                    proceedTxt={t("deleteAttendanceModal.proceedTxt")}
                    cancelTxt={t("deleteAttendanceModal.cancelTxt")}
                    title={t("deleteAttendanceModal.title")}
                    text={t("deleteAttendanceModal.text")}
                />
            )}
        </Fragment>
    );
};

export default StudentAttendanceData;
